import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type QuizDocument = {
   docid: number;
   doctype: 'guide' | 'wiki';
};

export async function unlockQuizzes(
   userid: number,
   documents: QuizDocument[],
   { ...common }: CommonRequestOptions
): Promise<void> {
   return makeRequest('patch', `/quizzes/sessions/userInvalidateAll/${userid}`, {
      ...common,
      body: {
         documents,
      },
   });
}
